<template>
  <div class="home-wrapper">

    <watch-location></watch-location>

    <v-alert error value="true" v-if="errorMessage">
      {{ errorMessage }}
    </v-alert>

    <div v-if="!googleMapsLoaded" class="mt-5">
      Loading Maps . . .
    </div>
    <map-component v-else></map-component>

    <v-dialog v-model="showUnlockDialog" lazy absolute>
      <v-card>
        <v-card-title>
          <div class="headline">
            Congratulations, you've unlocked a challenge!
          </div>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="green--text darken-1" flat="flat" @click.native="showUnlockDialog = false">
            Cancel
          </v-btn>
          <v-btn class="green--text darken-1" flat="flat" @click.native="goToQuestion(discoveredChallengeId)">
            Go to question
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <tutorial-dialog-component :game="this.game"></tutorial-dialog-component>

  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import * as VueGoogleMaps from 'vue2-google-maps'
  import MapComponent from '@/components/single/Map'
  import TutorialDialogComponent from '@/components/single/TutorialDialog'
  import watchLocation from '@/services/watchLocation'
  import { getChallengeById } from '../services/challengesUtils'
  import { challengeStatus } from '@/services/challengeStatus.enum'
//  import * as helpfulLocations from '../services/helpfulLocations'

  const actions = mapActions([
    'unlockQuestion',
    'setPositionToDefaultChallenge',
  ])

  const getters = mapGetters([
    'errorMessage',
    'isUserAtChallengeLocation',
    'tutorialInProgress',
    'challengesLocations',
    'game',
  ])

  let unwatchIsUserAtChallengeLocation
  let unwatchChallengesLocations

  export default {
    name: 'home',
    components: {
      MapComponent,
      watchLocation,
      TutorialDialogComponent,
    },
    data() {
      return {
        showUnlockDialog: false,
        discoveredChallengeId: null,
        googleMapsLoaded: false,
        needToUnlockDialogAfterTutorial: false,
      }
    },
    // https://router.vuejs.org/en/advanced/data-fetching.html
    beforeRouteEnter (to, from, next) {
      VueGoogleMaps.loaded
        .then(() => {
          next(vm => vm.setGoogleMapsLoaded(true))
        })
    },
    computed: {
      ...getters,
    },
    mounted() {

      // Inject fake locations... And go to a checkpoint
//      this.$store.commit('SET_USER_LOCATION', helpfulLocations.two)

//      setTimeout(() => {
//        this.$store.commit('SET_USER_LOCATION', helpfulLocations.three)
//      }, 1500)
//      setTimeout(() => {
//        this.$store.commit('SET_USER_LOCATION', wynyard)
//      }, 3000)
//      setTimeout(() => {
//        this.$store.commit('SET_USER_LOCATION', botanicGarden)
//      }, 4000)

      unwatchIsUserAtChallengeLocation = this.$watch('isUserAtChallengeLocation', () => {
        this.positionDefaultChallenge()
      })
      unwatchChallengesLocations = this.$watch('challengesLocations', () => {
        this.positionDefaultChallenge()
      })
    },
    watch: {
      isUserAtChallengeLocation: function (userAtChallengeLocation) {

        if (userAtChallengeLocation.isUserInOneZone) {

          const challengeId = userAtChallengeLocation.challengeId
          const challenge = getChallengeById(this.$store.state.challengesLocations, challengeId)

          if (challenge && challenge.status === challengeStatus.LOCKED) {

            this.unlockQuestion(challengeId)
              .then(questionResponse => {
                this.$store.commit('SET_ERROR_MESSAGE', '')
                // Unlock challenge (update state)
                this.$store.commit('UNLOCK_CHALLENGE', questionResponse.data)
              })
              .catch(err => {
                console.log('unlockQuestion() / server error', err)
                this.$store.commit('SET_ERROR_MESSAGE', 'Challenge could not be unlocked...')
                setTimeout(() => {
                  this.$store.commit('SET_ERROR_MESSAGE', '')
                }, 2000)
              })

            if (this.tutorialInProgress === false) {
              setTimeout(() => {
                this.openUnlockedDialog(challengeId)
              }, 500)
            } else {
              this.needToUnlockDialogAfterTutorial = true
            }
          }
        }
      },
      tutorialInProgress: function (isTutorialInProgress) {
        const challengeId = this.isUserAtChallengeLocation.challengeId
        if (isTutorialInProgress === false && this.needToUnlockDialogAfterTutorial) {
          this.needToUnlockDialogAfterTutorial = false
          setTimeout(() => {
            this.openUnlockedDialog(challengeId)
          }, 100)
        }
      },
    },
    methods: {
      ...actions,
      setGoogleMapsLoaded(loaded) {
        this.googleMapsLoaded = loaded
      },
      goToQuestion(challengeId) {
        this.showUnlockDialog = false
        this.$router.push({ name: 'Question', params: { id: challengeId } })
      },
      openUnlockedDialog(challengeId) {
        this.discoveredChallengeId = challengeId
        this.showUnlockDialog = true
      },
      positionDefaultChallenge() {
        if (this.challengesLocations && this.challengesLocations.length > 0 &&
            this.isUserAtChallengeLocation && this.isUserAtChallengeLocation.isUserInOneZone !== null) {
          this.setPositionToDefaultChallenge()
          unwatchIsUserAtChallengeLocation()
          unwatchChallengesLocations()
        }
      },
    },
  }
</script>

<style lang="scss" type="text/scss" scoped>

  .home-wrapper {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
  }

  .alert {
    margin: 0;
  }

  .dialog .headline {
    font-size: 21px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue